/* eslint-disable no-unused-vars */
import React, { lazy, Suspense } from 'react';
import {BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { ToastContainer, Zoom } from "react-toastify";
import AuthRoutes from "./AuthRoutes";
import PrivateRoutes from "./PrivateRoutes";
import ContentLoader from "../components/Loader";
import history from '../helpers/history';

const Routes = props => {
    const LoginAdmin = lazy(() => import('../pages/Auth/LoginAdmin'));
    const CreateAdmin = lazy(() => import('../pages/Auth/CreateAdmin'));
    const ForgotPasswordPage = lazy(() => import('../pages/Auth/ForgotPassword.js'));
    const CreatePasswordPage = lazy(() => import('../pages/Auth/CreatePassword.js'));
    const Dashboard = lazy(() => import('../pages/Dashboard'));
    const Admin = lazy(() => import("../pages/Admin"));
    const Roles = lazy(() => import("../pages/Role"));
    const Challenges = lazy(() => import("../pages/Challenges"));
    const Pots = lazy(() => import("../pages/Pots"));
    const Competitions = lazy(() => import("../pages/Competitions"));
    const ChallengeProgress = lazy(() => import("../pages/ChallengeProgress"));
    const Users = lazy(() => import("../pages/Users"));
    const Waitlist = lazy(() => import("../pages/Waitlist"));
    const Bookies = lazy(() => import("../pages/Bookies"));
    const Predict = lazy(() => import("../pages/Predict"));
    const Games = lazy(() => import("../pages/Games"));
    const Referral = lazy(() => import("../pages/Referral"));
    const Subscriptions = lazy(() => import("../pages/Subscriptions"));
    const Coins = lazy(() => import("../pages/Coins"));
    const Banners = lazy(() => import("../pages/Banners"));
    const Settings = lazy(() => import("../pages/Settings"));
    const Reports = lazy(() => import("../pages/Reports"));
    const Leaderboards = lazy(() => import("../pages/Leaderboards"));
    const Notifications = lazy(() => import("../pages/Notifications"));
    const PaymentsBilling = lazy(() => import("../pages/Payments & Billing"));
    const AuditTrial = lazy(() => import("../pages/AuditTrail"));
    const SearchWaitlist = lazy(() => import("../components/SearchWaitlist"));
    const Health = lazy(() => import("../pages/Health"));
    const Affiliates = lazy(() => import("../pages/Affiliates"));
    const PageNotFound = lazy(() => import("../pages/PageNotFound"));
    const Forbidden = lazy(() => import("../pages/AccessForbidden"));
    const LogoutAdmin = lazy(() => import('../pages/Auth/LogoutAdmin'));

  return (
    <>
      <BrowserRouter history={history}>
        <ToastContainer
          autoClose={5000}
          transition={Zoom}
          toastClassName="dark-toast"
        />
        <Suspense fallback={<ContentLoader type="TailSpin" color="#ccc" h="45" w="45" style={{ margin: "15rem auto", width: "5%",}}/>} >
          <Switch>
            <AuthRoutes exact path="/" component={LoginAdmin} />
            <AuthRoutes exact path="/logout" component={LogoutAdmin} isLogout={true} />
            <AuthRoutes exact path="/complete-profile" component={CreateAdmin} />
            <AuthRoutes exact path="/create-password" component={CreatePasswordPage} />

            <AuthRoutes
              exact
              path="/forgot-password"
              component={ForgotPasswordPage}
            />
            <PrivateRoutes exact path="/dashboard" component={Dashboard} requiredPermissionGroup={['Analytics Management']}/>
            <PrivateRoutes exact path="/admin" component={Admin} requiredPermissionGroup={['Admin Management']} />
            <PrivateRoutes exact path="/roles" component={Roles} requiredPermissionGroup={['Role Management', 'Permission Management']} />
            <PrivateRoutes exact path="/challenges" component={Challenges}  requiredPermissionGroup={['Challenge Management']}/>
            <PrivateRoutes exact path="/user-challenges" component={ChallengeProgress}  requiredPermissionGroup={['Challenge Management']}/>
            <PrivateRoutes exact path="/users" component={Users} requiredPermissionGroup={['User Management']} />
            <PrivateRoutes exact path="/users" component={Users} requiredPermissionGroup={['User Management']} />
            <PrivateRoutes exact path="/waitlist-users" component={Waitlist} requiredPermissionGroup={['Waitlist Management']} />
            <PrivateRoutes exact path="/subscriptions" component={Subscriptions} requiredPermissionGroup={['Subscription Plan Management']} />
            <PrivateRoutes exact path="/bookies" component={Bookies} requiredPermissionGroup={['Predict & Win Management']} />
            <PrivateRoutes exact path="/predict" component={Predict} requiredPermissionGroup={['Predict & Win Management']} />
            <PrivateRoutes exact path="/games" component={Games} requiredPermissionGroup={['Predict & Win Management']} />
            <PrivateRoutes exact path="/referrals" component={Referral} requiredPermissionGroup={['Predict & Win Management']} />
            <PrivateRoutes exact path="/banners" component={Banners} requiredPermissionGroup={['Predict & Win Management']} />
            <PrivateRoutes exact path="/settings" component={Settings} requiredPermissionGroup={['Predict & Win Management']} />
            <PrivateRoutes exact path="/reports" component={Reports} requiredPermissionGroup={['Predict & Win Management']} />
            <PrivateRoutes exact path="/leaderboards" component={Leaderboards} requiredPermissionGroup={['Predict & Win Management']} />
            <PrivateRoutes exact path="/notifications" component={Notifications} requiredPermissionGroup={['Notification Management', 'Email Management']} />
            <PrivateRoutes exact path="/payments" component={PaymentsBilling} requiredPermissionGroup={['Transfer Requests Management', 'Transfers Management']} />
            <PrivateRoutes exact path="/audit" component={AuditTrial} requiredPermissionGroup={['Bookmakers Management']} />
            <PrivateRoutes exact path="/search-predictions" component={SearchWaitlist} requiredPermissionGroup={['Bookmakers Management']} />
            <PrivateRoutes exact path="/health" component={Health} requiredPermissionGroup={['Uptime Management']} />
            <PrivateRoutes exact path="/bundles" component={Coins} requiredPermissionGroup={['Bundle Management']} />
            <PrivateRoutes exact path="/pots" component={Pots} requiredPermissionGroup={['Gaming Management']}/>
            <PrivateRoutes exact path="/ranked-bookings" component={Competitions} requiredPermissionGroup={['Gaming Management']}/>
            <PrivateRoutes exact path="/affiliates" component={Affiliates} requiredPermissionGroup={['Affiliate Management']} />
            <PrivateRoutes exact path="/404" component={PageNotFound} />
            <PrivateRoutes exact path="/403" component={Forbidden} />
            <Redirect to="/404" />
          </Switch>
        </Suspense>
      </BrowserRouter>
    </>
  );
};


export default Routes;